import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useInitialize from "./useInitialize";
import useStore from "./useStore";
import BeelditGenericForm from "@beeldit/core/components/BeelditGenericForm";
import { CreateActionContext } from "./CreateActionContext";
import context from "react-bootstrap/esm/AccordionContext";
import { filter } from "lodash";

function useCreateAction(modelConfig: any, index: any, formDefaultValues: any = {}, formFilterValues = {}): any {
  const initialize = useInitialize();
  const initializeFunction = () => initialize(formDefaultValues);

  /**
   * Form store success function definition
   */
  const onSuccessStore = () => {
    setShowModal(false);
    index(); // We pass the function to refresh the table on success
  };

  const store = useStore(modelConfig);
  const storeFunction = () => store(onSuccessStore);

  /** Creation and edition modal function and state definition */
  const { showModal, setShowModal } = useContext(CreateActionContext);

  /** Creation and edition modal element definition */
  const contextInstance = useContext(CreateActionContext);
  const { element } = contextInstance;

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: "Create " + modelConfig.modelName,
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(), //We pass the function for the submit of the modal
    fullscreen: modelConfig.modalFullScreen,
    detectChanges: true,
  };

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      storeFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    contextInstance: contextInstance,
    filterData: formFilterValues, // We pass the filters to the form
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <BeelditGenericForm formConfig={formConfig} modelConfig={modelConfig}/>
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    initializeFunction,
    actionTemplate,
    showModal,
  };
}

export default useCreateAction;
